<template>
  <div class="enter_container">
    <el-dialog
      title="商业咨询"
      :visible.sync="value"
      width="700px"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formRef"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="form.userName" class="input_width"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" class="input_width"></el-input>
        </el-form-item>
        <el-form-item label="公司名" prop="companyName">
          <el-input v-model="form.companyName" class="input_width"></el-input>
        </el-form-item>
        <!-- <el-form-item label="应用名" prop="appName">
          <el-input v-model="form.appName" class="input_width"></el-input>
        </el-form-item> -->
        <el-form-item label="咨询事宜" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            class="input_width"
          ></el-input>
          <div style="padding-top: 12px; color: #cccccc">
            请输入您要咨询的事项,我们将尽快与您取得联系
          </div>
        </el-form-item>
      </el-form>
      <!-- 底部按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('input', false)">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit('formRef')"
          :loading="loading"
        >
          确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchEnterpriseBusiness } from '@/api/enteriseApp';
export default {
  name: 'Enter',
  components: {},
  data() {
    return {
      form: {},
      rules: {
        userName: [
          { required: true, message: '请输入姓名' },
          { max: 16, message: '姓名不能大于16个字符' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码' },
          {
            min: 11,
            max: 11,
            message: '请输入合法的手机号码'
          }
        ],
        companyName: [{ required: true, message: '请输入公司名称' }],
        appName: [{ required: true, message: '请输入应用名称' }],
        content: [
          { required: false },
          {
            max: 255,
            message: '咨询事宜不能多于255个字符'
          }
        ]
      },
      // 按钮loading
      loading: false
    };
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
    appDetailInfo: {
      type: Object,
      required: true
    }
  },
  computed: {},
  watch: {
    appDetailInfo: {
      handler: function(val) {
        this.form = Object.assign({}, { appName: val.name });
      },
      immediate: true
    }
  },
  created() {},
  methods: {
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = Object.assign(
            {},
            {
              appKeyID: this.appDetailInfo.appKeyID,
              marketID: this.appDetailInfo.marketID
            },
            this.form
          );
          fetchEnterpriseBusiness(params)
            .then((res) => {
              if (res && res.Code === '200') {
                this.$message({
                  type: 'success',
                  message: '提交成功!'
                });
                this.loading = false;
                this.handleClose();
              }
            })
            .catch((err) => {
              err &&
                this.$message({
                  type: 'error',
                  message: '提交失败!'
                });
              this.loading = false;
            });
        }
      });
    },
    handleClose() {
      this.$emit('input', false);
    }
  }
};
</script>

<style scoped lang="scss">
.input_width {
  width: 360px;
}
</style>



// WEBPACK FOOTER //
// src/views/appstore/components/Enter.vue